module.exports = __webpack_public_path__ + "static/media/icon-15.29ba3734.png";